import { factoryService, getJsonRequest } from '@chilecompra/react-kit/requests'
import { REACT_APP_API_BUYER_CARD_BASE_URL } from '../config/settings/environment'

/**
 * Gets the Annual Purchase Plan data.
 */
export const getAnnualPurchasePlan = factoryService(({ dni }) => {
  return getJsonRequest(`${REACT_APP_API_BUYER_CARD_BASE_URL}/plan_compra/montos?rut=${dni}`)
})

/**
 * Gets the Outside Annual Purchase Plan data.
 */
export const getOutsideAnnualPurchasePlan = factoryService(({ dni, page, size }) => {
  return getJsonRequest(
    `${REACT_APP_API_BUYER_CARD_BASE_URL}/plan_compra/oc_fuera_pac?rut=${dni}&page=${page}&size=${size}`
  )
})
